namespace GeniuzPOS.AdvPromo {
    export class Report_Adv03Columns {
        static columnsKey = 'AdvPromo.Report_Adv03';
    }
}
